
































































































































































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { InputAuthor } from '@/components/molecules/InputAuthor'
import { InputPublisher } from '@/components/molecules/InputPublisher'
import { AuthorityItem, Prefix, SearchType } from '@/types'

export interface InterLibraryLoanCollectionEntryFormBibliographyItem {
  id: number
  prefix: Prefix
  searchType: {
    input: SearchType
    errorMessage: string
  }
  materialFormat: {
    input: string
    errorMessage: string
  }
  titleDisplay: {
    input: string
    errorMessage: string
  }
  titleKana: {
    input: string
    errorMessage: string
  }
  authorDisplay: {
    input: string
    errorMessage: string
  }
  authorKana: {
    input: string
    errorMessage: string
  }
  authorNo: {
    input: string
    errorMessage: string
  }
  publisherDisplay: {
    input: string
    errorMessage: string
  }
  publisherKana: {
    input: string
    errorMessage: string
  }
  publisherNo: {
    input: string
    errorMessage: string
  }
  isbn: {
    input: string
    errorMessage: string
  }
  etcType: {
    input: string
    errorMessage: string
  }
  etcNo: {
    input: string
    errorMessage: string
  }
  classNo: {
    input: string
    errorMessage: string
  }
}

export const defaultInterLibraryLoanCollectionEntryFormBibliographyItem = (): InterLibraryLoanCollectionEntryFormBibliographyItem => ({
  id: 0,
  prefix: Prefix.Real,
  searchType: {
    input: SearchType.Book,
    errorMessage: ''
  },
  materialFormat: {
    input: '',
    errorMessage: ''
  },
  titleDisplay: {
    input: '',
    errorMessage: ''
  },
  titleKana: {
    input: '',
    errorMessage: ''
  },
  authorDisplay: {
    input: '',
    errorMessage: ''
  },
  authorKana: {
    input: '',
    errorMessage: ''
  },
  authorNo: {
    input: '',
    errorMessage: ''
  },
  publisherDisplay: {
    input: '',
    errorMessage: ''
  },
  publisherKana: {
    input: '',
    errorMessage: ''
  },
  publisherNo: {
    input: '',
    errorMessage: ''
  },
  isbn: {
    input: '',
    errorMessage: ''
  },
  etcType: {
    input: '',
    errorMessage: ''
  },
  etcNo: {
    input: '',
    errorMessage: ''
  },
  classNo: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode,
    InputAuthor,
    InputPublisher
  }
})
export default class InterLibraryLoanCollectionEntryFormBibliography extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InterLibraryLoanCollectionEntryFormBibliographyItem

  @Prop({
    type: Boolean,
    default: false
  })
  isDisplaySearchType!: boolean

  get searchType(): any {
    return SearchType
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onInputAuthor(item: AuthorityItem): void {
    this.inputItem.authorKana.input = item.displayKana
    this.inputItem.authorDisplay.input = item.display
  }

  onInputPublisher(item: AuthorityItem): void {
    this.inputItem.publisherKana.input = item.displayKana
    this.inputItem.publisherDisplay.input = item.display
  }
}
